export default {
  loadingScreenContainer: {
    textAlign: 'center',
    padding: '40px 0',
  },
  loadingScreenSpinnerContainer: {
    marginBottom: '20px',
  },
};
